module.exports = __webpack_public_path__ + "static/media/Start.5f49c07e.mp3";